import { Box, List, ListItem, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const UsageGuide: React.FC = () => {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 2, pl: 1 }}>
      <Typography variant="body2" sx={{ fontSize: '1rem', mb: 1 }}>
        <strong>Usage Guide:</strong>
      </Typography>
      <List
        dense
        sx={{
          listStyleType: 'disc',
          pl: 2,
          '& .MuiListItem-root': { display: 'list-item', py: 0.2, px: 0, fontSize: '1rem' },
        }}
      >
        <ListItem>
          <strong>Outlines:</strong> Use the extracted outline, or choose a standard structure.
        </ListItem>
        <List
          dense
          sx={{
            listStyleType: 'circle',
            pl: 4,
            mt: 0.5,
            '& .MuiListItem-root': {
              display: 'list-item',
              py: 0.2,
              px: 0,
              fontSize: '0.95rem',
            },
          }}
        >
          <ListItem>
            Use <strong>"Extracted (Exclude Forms)"</strong> to load a narrative outline that omits
            sections already covered by the detected forms.
          </ListItem>
          <ListItem>
            Use <strong>"Extracted (Full)"</strong> to load the complete structure, including
            duplicated forms content.
          </ListItem>
        </List>
        <ListItem>
          <strong>Edit:</strong> Click on any heading text to edit it directly.
        </ListItem>
        <ListItem>
          <strong>Reorder:</strong> Drag & Drop items to change their order.
        </ListItem>
        <ListItem>
          <strong>Hierarchy:</strong> Drag Right/Left to change indentation (up to 4 levels).
        </ListItem>
        <ListItem>
          <strong>Focusers (Optional):</strong> Add brief instructions (e.g., &quot;450 words&quot;,
          &quot;three phases, between March and August&quot;, &quot;John Smith&quot;) to guide the
          AI for specific sections.
        </ListItem>
        <ListItem>
          <strong>Duplicates:</strong> Potential duplicates are highlighted in{' '}
          <Box component="span" sx={{ color: theme.palette.bidlogiq.brick, fontWeight: 'bold' }}>
            orange
          </Box>
          .
        </ListItem>
      </List>
    </Box>
  );
};

export default UsageGuide;
